import { GameTrivia, TriviaList } from '@repo/types'
import { Container, Heading, Panel } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { AppHeader } from '@/components/AppHeader'
import { BackButton, CloseButton } from '@/components/icon-buttons/IconButtons'
import { Main } from '@/components/Main'
import { Page } from '@/components/Page'
import { PageHeading } from '@/components/PageHeading'
import { useUpdateUserTriviaList } from '@/pages/trivia-lists/queries/useUpdateUserTriviaList'
import { updateGameSetting } from '@/store/game/updateGameDocument'
import StoreService from '@/store/StoreService'

import {
  JumbotronDefaultVideoFormValues,
  JumbotronDefaultVideoForm
} from './JumbotronDefaultVideoForm'

export const JumbotronDefaultVideoTrivia = observer(() => {
  const { currentGame } = StoreService.getStore()
  const history = useHistory()

  if (!currentGame || currentGame.gameData.type !== 'trivia') {
    return null
  }

  const gameData = currentGame.gameData as GameTrivia
  const listId = gameData.sourceListMeta.id

  const { mutate: updateUserTriviaList } = useUpdateUserTriviaList({ listId })

  const currentValues = {
    video: gameData.sourceListMeta.video?.url,
    videoPreGame: gameData.sourceListMeta.videoPreGame?.url
  }

  const handleClickBack = () => {
    history.goBack()
  }

  const handleClickClose = () => {
    history.push('/game')
  }

  const handleSubmit = async (values: JumbotronDefaultVideoFormValues) => {
    if (!currentGame || currentGame.gameData.type !== 'trivia') return

    const updates = {
      ...currentValues,
      ...values
    }

    const update = {
      ['sourceListMeta.video.url']: updates.video,
      ['sourceListMeta.videoPreGame.url']: updates.videoPreGame
    }

    await updateGameSetting(currentGame.gameId, update)

    const updatedTriviaList: TriviaList = {
      ...gameData.sourceListMeta,
      video: {
        url: updates.video
      },
      videoPreGame: {
        url: updates.videoPreGame
      }
    }

    updateUserTriviaList(updatedTriviaList)
  }

  const handleSuccess = () => {
    history.push('/game')
  }

  return (
    <Page title='Jumbotron Videos'>
      <AppHeader
        actionsLeft={<BackButton onClick={handleClickBack} />}
        actionsRight={<CloseButton onClick={handleClickClose} />}
        header={<PageHeading>Jumbotron Settings</PageHeading>}
      />

      <Main>
        <Container size='medium'>
          <Panel className='flex flex-col gap-6'>
            <Heading>Videos</Heading>

            <JumbotronDefaultVideoForm
              onSubmit={handleSubmit}
              onSuccess={handleSuccess}
              {...currentValues}
            />
          </Panel>
        </Container>
      </Main>
    </Page>
  )
})
